import { Link } from '@tanstack/react-router';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorSection } from 'src/components/sections/ErrorSection';
import { Button } from 'src/components/ui/button';

type NotFoundFeatureProps = {
  route: string;
  routeTitle: string;
};

export function NotFoundFeature({
  route,
  routeTitle,
}: NotFoundFeatureProps): ReactElement {
  const { t } = useTranslation('errors');

  return (
    <ErrorSection
      code={404}
      title={t('Page not found')}
      description={t('We could not find the page')}
      action={
        <Button>
          <Link to={route}>{routeTitle}</Link>
        </Button>
      }
    />
  );
}
